// @flow

import nbNO from "./nb_NO.json"
import type { Locale } from "../types/IntlTypes"
import enGB from "./en_GB.json"

const locale: Locale = {
  messages: { ...enGB, ...nbNO },
  name: "no"
}

export default locale
